module.exports = __webpack_public_path__ + "img/電気回路_2_7.8c325525.png";